export const guideColor = "#61D3FB";
export const stageDimensions = {
  width: 960,
  height: 540,
};
